import Inspiration from "../assets/images/inspiration.png";
import MindBlowingImg from '../assets/images/mind_blowing.png';
import MasterMind from '../assets/images/mastermind.png';
import AllInImg from '../assets/images/all_in.png';
import VideoImg from '../assets/images/video.png';
import Video2Img from '../assets/images/vid_2.png';
import AlwaysOnImg from '../assets/images/alwaysOn.png';
import { motion } from 'framer-motion';
import ReactPlayer from 'react-player/lazy'


const Exibition = () => {
  return (
    <section className="exibition_section" id="learn_more" >
      <div className="exibition_section_tittle">Xceptia LDX Air</div>

      <a href="#preorder" className="exibition_section_button">
        Find a Store
      </a>

      <div className="exibition_section_split">

        {/* <motion.div className="exibition_section_split_left"
        
       initial={{ scale: 0.5,}}
                whileInView={{ scale: 1, }}
                transition={{ duration: 0.4 }}
                viewport={{ once: true }}

        > */}
        <motion.img
          className="exibition_section_split_left"
          alt=""
          // style={{
          //   width:"100%",
          //   height:"100%"
          // }}
          src={Inspiration}
          initial={{ scale: 0.5, }}
          whileInView={{ scale: 1, }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
        />
        {/* </motion.div> */}

        <motion.div className="exibition_section_split_right"

          initial={{ transform: 'translateX(300px)' }}
          whileInView={{ transform: 'translateX(0px)' }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}

        >

          <img className="exibition_section_split_right_top" alt="" src={MindBlowingImg} />

          <img className="exibition_section_split_right_btm" alt="" src={MasterMind} />

        </motion.div>

      </div>

      <motion.div
        className="exibition_section_sep"
        initial={{ transform: 'translateY(300px)' }}
        whileInView={{ transform: 'translateY(0px)' }}
        transition={{ duration: 0.4 }}
        viewport={{ once: true }}
      >

        <img className="exibition_section_sep_left" alt="" src={AllInImg} />

        <div className="exibition_section_sep_right video1 bg-#fffff rounded w">
          <ReactPlayer playIcon url='https://cdn.rorbible.plus/media/video/xceptia/xceptia_version1.mp4' controls='true' height={'90%'} width={`100%`}
            style={{
              borderRadius: 40,
            }} />
        </div>

      </motion.div>



      <div className="exibition_section_dif" >

        {/* <motion.img
          className="exibition_section_dif_left" alt=""
          src={Video2Img}
          initial={{ transform: 'translateX(-300px)' }}
          whileInView={{ transform: 'translateX(0)' }}
          transition={{ duration: 0.4 }}
          viewport={{ once: true }}
        /> */}

        <div className="exibition_section_dif_left"
          style={{
            borderRadius: 40,
            width:'35%'
          }} >
          <ReactPlayer url='https://cdn.rorbible.plus/media/video/xceptia/xceptia_version2.mp4' controls='true' width={'100%'}
            style={{
              borderRadius: 40,
              
            }} />
        </div>


        <motion.img
          className="exibition_section_dif_right" alt="" src={AlwaysOnImg}
          // initial={{ transform: 'rotateY(-30deg) translateY(300px) skewY(30deg)' }}
          // whileInView={{ transform: 'rotateY(0deg) translateY(0) skewY(0deg)' }}
          // transition={{ duration: 0.4 }}
          viewport={{ once: true }}
        />

      </div>

    </section>
  );
};

export default Exibition;
